import {BigNumber, utils} from 'ethers';
import {useEffect, useState} from 'react';

import {isServer} from '../_helper/isServer';

const useEstimateGasFee = (gasUsage: number, gasPrice?: number): number => {
    if (isServer()) return 0;
    const [data, setData] = useState(0);

    useEffect(() => {
        if (gasPrice) {
            const gasFee = (BigNumber.from(gasUsage).mul(BigNumber.from(gasPrice))).toString();
            setData(Number(utils.formatEther(gasFee)));
        }
    }, [gasPrice]);

    return data;
}

export default useEstimateGasFee;